

const StarRating = ({ rating }) => {
  return (
    <span className="stars">
      {[...Array(5)].map((_, i) => (
        <span key={i}>{i < rating ? "⭐" : "☆"}</span>
      ))}
    </span>
  );
};

export default StarRating;
